import { useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { Menu, X } from "lucide-react";
import { useLang } from "@/context/LanguageContext";

const links = [
  { to: "/", key: "home" },
  { to: "/historia", key: "historia" },
  { to: "/ministerios", key: "ministerios" },
  { to: "/sermones", key: "sermones" },
  { to: "/eventos", key: "eventos" },
  { to: "/contacto", key: "contacto" },
];

export const Navbar = () => {
  const { lang, setLang, t } = useLang();
  const location = useLocation();
  const navigate = useNavigate();
  const [open, setOpen] = useState(false);

  return (
    <header className="fixed top-0 left-0 right-0 z-50 backdrop-blur-xl bg-black/60 border-b border-white/10">
      <div className="max-w-7xl mx-auto px-6 md:px-10 h-16 flex items-center justify-between">
        <Link to="/" data-testid="nav-logo" className="flex items-center gap-3">
          <span className="block w-9 h-9 rounded-full overflow-hidden border border-white/20">
            <img src="/logo.jpg" alt="Movimiento Church" className="w-full h-full object-cover scale-[1.65]" />
          </span>
          <span className="text-sm tracking-[0.3em] uppercase font-semibold text-white">
            Movimiento
          </span>
        </Link>

        <nav className="hidden lg:flex items-center gap-8" data-testid="nav-links">
          {links.map((l) => (
            <Link
              key={l.key}
              to={l.to}
              data-testid={`nav-link-${l.key}`}
              className={`text-xs uppercase tracking-[0.2em] transition-colors duration-300 ${
                location.pathname === l.to ? "text-ember" : "text-white/60 hover:text-white"
              }`}
            >
              {t.nav[l.key]}
            </Link>
          ))}
        </nav>

        <div className="flex items-center gap-4">
          <button
            data-testid="lang-toggle"
            onClick={() => setLang(lang === "es" ? "en" : "es")}
            className="text-xs tracking-[0.2em] uppercase border border-white/20 rounded-full px-3 py-1.5 text-white/70 hover:border-ember hover:text-white transition-colors duration-300"
          >
            <span className={lang === "es" ? "text-ember" : ""}>ES</span>
            <span className="text-white/30 mx-1">/</span>
            <span className={lang === "en" ? "text-ember" : ""}>EN</span>
          </button>
          <button
            data-testid="nav-donate-btn"
            onClick={() => navigate("/donar")}
            className="hidden sm:block text-xs uppercase tracking-[0.2em] bg-ember text-white rounded-full px-5 py-2 hover:bg-sand hover:text-ink transition-colors duration-300"
          >
            {t.nav.donar}
          </button>
          <button
            data-testid="mobile-menu-btn"
            onClick={() => setOpen(!open)}
            className="lg:hidden text-white"
            aria-label="Menu"
          >
            {open ? <X size={22} /> : <Menu size={22} />}
          </button>
        </div>
      </div>

      {open && (
        <nav className="lg:hidden border-t border-white/10 bg-ink/95 px-6 py-6 flex flex-col gap-5" data-testid="mobile-menu">
          {links.map((l) => (
            <Link
              key={l.key}
              to={l.to}
              onClick={() => setOpen(false)}
              data-testid={`mobile-nav-link-${l.key}`}
              className={`text-sm uppercase tracking-[0.2em] ${
                location.pathname === l.to ? "text-ember" : "text-white/70"
              }`}
            >
              {t.nav[l.key]}
            </Link>
          ))}
          <Link
            to="/donar"
            onClick={() => setOpen(false)}
            data-testid="mobile-nav-link-donar"
            className="text-sm uppercase tracking-[0.2em] text-ember"
          >
            {t.nav.donar}
          </Link>
        </nav>
      )}
    </header>
  );
};
